import { SubjectPaginateRequest } from "./../../../../cadastro/admin/models/subject/subject-paginate-request"
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core"
import { OrderTableEnum } from "src/app/cadastro/admin/models/enums/orderTableEnum"
import { SubjectPaginateResponse } from "src/app/cadastro/admin/models/subject/subject-paginate-response"
import { DEFAULT_PAGE_SIZE } from "src/app/cadastro/admin/lib/constants"
import { ErrorHandlerService } from "src/app/cadastro/admin/services/error-handler.service"
import { SubjectService } from "src/app/cadastro/admin/services/subject.service"
import { FilterState } from "src/app/cadastro/admin/services/states/filter.state"
import { AppService } from "src/app/core/services/app.service"
import { Helpers } from "src/app/helpers"
import { TableSchema } from "src/app/core/models/Table"
import { LexTranslateService } from "src/app/core/services/lex-translate.service"

@Component({
  selector: "seb-subject-table",
  templateUrl: "./subject-table.component.html",
  styleUrls: ["./subject-table.component.css"],
})
export class SubjectTableComponent implements OnInit {
  @Output() buttonId = new EventEmitter()
  preloader: boolean = true
  filter: SubjectPaginateRequest = new SubjectPaginateRequest()
  paginationSize: number
  @Input() filterSubject: string = ""
  isBackOfficeConexia: boolean = false
  subjectsTable: TableSchema<any> = {columns: [], data:[]}

  errorHandler: (err: any) => void

  constructor(
    private errorHandlerService: ErrorHandlerService,
    private subjectService: SubjectService,
    private filterState: FilterState,
    private appService: AppService,
    public lextranslate: LexTranslateService
  ) {
    this.errorHandler = this.errorHandlerService.handle(
      "status",
      "filter_groups_error",
      "status"
    )
  }

  async ngOnInit() {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()
    const filterStateFields = this.filterState.states.filterFields as any

    this.subjectsTable = {
      columns: [
        {
          id: "name",
          name:  this.lextranslate.i18n["4e7d56a3-8a46-452d-a4e8-6aae1b80c8ae"],
          width: "15%",
          ordination: { orderType: OrderTableEnum.Ascending },
        },
        {
          id: "description",
          name: this.lextranslate.i18n["114dda32-3b0a-4ac1-87f5-8e341b39b79c"],
          width: "15%",
          ordination: { orderType: OrderTableEnum.Ascending },
        },
        {
          id: "sets",
          name: this.lextranslate.i18n["65c103a9-7145-4702-a027-3cb66880880b"],
          width: "30%",
          foldable: {
            content: "foldableGrade",
            bindLabel: "setName",
          },
        },
        {
          id: "actionButtonGroup",
          name: this.lextranslate.i18n["e4f0c057-4cfc-4c8f-8629-0028f33e4f16"],
          width: "0%",
          showtooltipIcon: true,
          tooltipText:
          this.lextranslate.i18n["4dca19b2-0d06-4051-b54c-ccf4b8b68e0d"],
          disabledDeleteButton: "disabledDeleteButton",
          actionGroupButton: {
            actionEditId: "editSubject",
            actionEditTitle:  this.lextranslate.i18n["8c38f94b-251a-4f42-ad5b-bd7edf68b869"],
            iconEdit: "edit",
            customIconEditClass: "addButton",

            actionDeleteId: "deleteSubject",
            actionDeleteTitle:  this.lextranslate.i18n["49ece551-f1c8-4d27-9495-51302d0a44ec"],
            iconDelete: "delete",
            customIconDeleteClass: "deleteButton",
          },
          ngStyle: {
            width: "100%",
          },
        },
      ],
      data: [],
    }

    this.filter = {
      limit: DEFAULT_PAGE_SIZE,
      page: 1,
      isDesc: false,
      orderByProperty: "name",
      name: filterStateFields.Name,
    }

    this.checkBackOffice()
    this.getPaginated()
  }

  checkBackOffice() {
    const currentRole = this.appService.currentUser.role
    if (currentRole !== "conexia") {
      this.subjectsTable.columns.pop()
    }
  }

  onFilter(value: any) {
    this.filter.page = 1
    this.filter.name = value.Name
    this.getPaginated()
  }

  getPaginated() {
    this.preloader = true
    this.subjectService
      .getPaginate(this.filter)
      .subscribe((data: SubjectPaginateResponse) => {
        for (const item of data.data) {
          item.disabledDeleteButton = false
          item.foldableGrade = []
          for (const set1 of item.sets) {
            item.foldableGrade.push({
              setName: set1,
              ngStyle: { backgroundColor: "#217aba" },
            })
            item.disabledDeleteButton = true
          }
        }
        this.subjectsTable.data = data.data
        this.paginationSize = data.totalRecords
        this.preloader = false
      }, this.errorHandler)
  }

  onIndexPag(event: number) {
    this.filter.page = event
    this.getPaginated()
  }

  onOrder(column) {
    this.filter.page = 1
    this.filter.orderByProperty = column.id
    this.filter.isDesc = column.isDesc
    this.getPaginated()
  }

  actionButtonGroup(event) {
    this.buttonId.emit(event)
  }
}
